<template>
  <div id="SearchResults" class="row">
    <div class="col-12">
      <div class="row mt-3 mt-lg-0">
        <div class="col-6">
          <!-- <button type="button" class="btn btn-primary btn-sm float-left mr-2">
            <i class="fas fa-map-marked-alt"></i>
            Map View
          </button> -->
          <OrderPicker v-model="order" @input="orderUpdated" class="float-left" />
        </div>
        <div class="col-6 text-right">
          <span class="mr-2">
            <i class="fas fa-filter"></i>
            {{$t('browse_now.filter')}}
          </span>
          <LocationPicker class="mt-2 mt-lg-0" v-model="location" />
          <ProviderTypePicker @input="reloadProviders" v-model="type" class="ml-2 mt-2 mt-lg-0" />
        </div>
      </div>
      <div class="row">
        <div
          class="col-6 col-md-4"
          v-for="(provider, index) in providers.data"
          v-bind:key="provider._id"
        >
          <div>
            <ProviderCard v-model="providers.data[index]" :serviceId="providerFilters.categoryIds[0]" />
          </div>
        </div>
      </div>
      <div
        class="row provider-list justify-content-center pt-5"
        v-if="!providers.loading && providers.resultKey && !providers.enableLoadMore"
      >
        <button
          href="#"
          class="btn btn-secondary"
          @click="providers.enableLoadMore = true"
        >Load More</button>
      </div>
      <div class="row pt-5" v-if="providers.enableLoadMore">
        <div class="col-12">
          <infinite-loading
            :identifier="providers.resultSet"
            @infinite="nextPage"
            forceUseInfiniteWrapper="page-body"
            :distance="50"
          >
            <div slot="spinner" class="loading"></div>
            <div slot="no-more">No more result</div>
            <div slot="no-results">No results message</div>
          </infinite-loading>
        </div>
      </div>
      <div v-else class="row pt-5">
        <div class="col-12 text-center">
          <div class="loading" v-if="providers.loading"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.provider-card {
  margin-top: 15px;
  margin-bottom: 15px;
}
.loading {
  margin: 20px;
  display: inline-block;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #ffbe17;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 0.9s linear infinite;
  animation: spin 0.8s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<script>
// lib url: https://www.npmjs.com/package/vue-infinite-loading
import InfiniteLoading from "vue-infinite-loading";
import { mapState } from "vuex";
import ProviderCard from "@/components/ProviderCard";
import OrderPicker from "@/components/OrderPicker";
import LocationPicker from "@/components/LocationPicker";
import ProviderTypePicker from "@/components/ProviderTypePicker";
// @ is an alias to /src

export default {
  name: "SearchResults",
  components: {
    ProviderCard,
    InfiniteLoading,
    OrderPicker,
    LocationPicker,
    ProviderTypePicker
  },
  computed: {
    ...mapState(["providerFilters"])
  },
  data() {
    return {
      providers: {
        resultSet: "",
        enableLoadMore: false,
        resultKey: null,
        error: null,
        loading: false,
        data: [],
        providerIds: {} // to check duplicated ids
      },
      order: {
        distance: 0,
        price: 0,
        rating: 0
      },
      type: "",
      location: {}
    };
  },
  watch: {
    providerFilters: {
      deep: true,
      handler() {
        this.$store.dispatch("loadLocation");
        this.reloadProviders();
      }
    },
    location: {
      deep: true,
      handler() {
        this.reloadProviders();
      }
    }
  },
  methods: {
    orderUpdated() {
      console.log(this.order);
      this.reloadProviders();
    },
    async nextPage(loadingState) {
      // console.log("nextPage");

      await this.fetchProviders();
      if (this.providers.resultKey) {
        loadingState.loaded();
      } else {
        loadingState.complete();
      }
    },
    // async fetchProviders() {
    //   const {data} = await this.$oddjob.settings.getConfigs();
    //   console.log('configs',data);
    //   let defaultRadius;
    //   if(data.results && data.results.length && data.results[0].default_radius){
    //       defaultRadius = data.results[0].default_radius;
    //   }
    //   // IMPORTANT: must use this providers context beacause filters could be changed during fetching data.
    //   const providers = this.providers;
    //   if (providers.loading == true) {
    //     return;
    //   }
    //   providers.loading = true;

    //   const resultFilter = {
    //     resultKey: providers.resultKey
    //   };

    //   if (this.type && this.type.length) {
    //     resultFilter.providerTypes = [this.type];
    //   }

    //   let loader = null;
    //   if (this.location && this.location.districtId) {
    //     loader = this.$oddjob.serviceProviders
    //       // .getServiceProviders({
    //       .findByLocations({
    //         ...resultFilter,
    //         maxDistance: defaultRadius,
    //         text: this.providerFilters.searchText,
    //         categories: this.providerFilters.categoryIds,
    //         limit: this.providerFilters.limit,
    //         order: this.order,
    //         areaId: this.location.districtId
    //       });
    //       console.log("findByLocations have districtId");
    //   } else if (
    //     this.providerFilters.location &&
    //     this.providerFilters.location.latitude
    //   ) {
    //     let { latitude, longitude } = this.providerFilters.location;
    //     loader = this.$oddjob.serviceProviders
    //       // .getServiceProviders({
    //       .findByLocations({
    //         ...resultFilter,
    //         maxDistance: defaultRadius || 100000,
    //         text: this.providerFilters.searchText,
    //         categories: this.providerFilters.categoryIds,
    //         limit: this.providerFilters.limit,
    //         order: this.order,
    //         center: `${longitude},${latitude}`
    //       });
    //        console.log("findByLocations");
    //   } else {
    //     console.log(`vao nek`, {
    //             ...resultFilter,
    //         text: this.providerFilters.searchText,
    //         categories: this.providerFilters.categoryIds,
    //         limit: this.providerFilters.limit,
    //         order: this.order
    //     });
    //     loader = this.$oddjob.serviceProviders
    //       // .getServiceProviders({
    //       .findSimple({
    //         ...resultFilter,
    //         text: this.providerFilters.searchText,
    //         categories: this.providerFilters.categoryIds,
    //         limit: this.providerFilters.limit,
    //         order: this.order
    //       });
    //     console.log("findSimple");
    //   }

    //   return loader
    //     .then(res => {
    //       console.log(`json ok`, res);
    //       return new Promise(done => {
    //         setTimeout(() => {
    //           done(res);
    //         }, 50);
    //       });
    //     })
    //     .then((res) => {
    //       providers.loading = false;
    //       res.data.results.forEach(item => {
    //         if (!this.providers.providerIds[item.provider._id]) {
    //           providers.data.push(item);
    //           console.log("vao item nek", item);
    //           this.providers.providerIds[item.provider._id] = item;
    //         }
    //       });
    //       console.log(`loader results`, res.data.results);
    //       console.log(`loader providerIds`, this.providers.providerIds);
    //       // providers.data.push(...res.data.results);
    //       // this.$nextTick(() => {
    //       //   this.providers.loading = false;
    //       //   this.providers.data = res.data.results;f
    //       //   console.log(this.providers.data);
    //       // });
    //       providers.resultKey = res.data.meta ? res.data.meta.resultKey : null;
    //       this.$forceUpdate();
    //     })
    //     .catch(err => {
    //       providers.error = err;
    //     });
    // },
      async loadData(data){
        console.log("data", data);
        this.providers.loading = false;
        data.results.forEach( item => {
          if (!this.providers.providerIds[item.provider._id]) {
              this.providers.data.push(item);
              this.providers.providerIds[item.provider._id] = item;
          }
        });
        this.providers.resultKey = data.meta ? data.meta.resultKey : null;
        this.$forceUpdate();
      },
      async fetchProviders() {

        const { data } = await this.$oddjob.settings.getConfigs();
        console.log('configs',data);

        let defaultRadius;
        if(data.results && data.results.length && data.results[0].default_radius){
            defaultRadius = data.results[0].default_radius;
        }
        // IMPORTANT: must use this providers context beacause filters could be changed during fetching data.
        const providers = this.providers;
        if (providers.loading == true) {
          return;
        }
        providers.loading = true;

        const resultFilter = {
          resultKey: providers.resultKey
        };

        if (this.type && this.type.length) {
          resultFilter.providerTypes = [this.type];
        }

        if (this.location && this.location.districtId) {
          const { data } = await this.$oddjob.serviceProviders
            .findByLocations({
              ...resultFilter,
              maxDistance: defaultRadius,
              text: this.providerFilters.searchText,
              categories: this.providerFilters.categoryIds,
              limit: this.providerFilters.limit,
              order: this.order,
              areaId: this.location.districtId
            });
          await this.loadData(data);

        } else if (
          this.providerFilters.location &&
          this.providerFilters.location.latitude
        ) {
          console.log('vao providerFilters', this.providerFilters);
          let { latitude, longitude } = this.providerFilters.location;
          const {  data  } = await this.$oddjob.serviceProviders
            .findByLocations({
              ...resultFilter,
              text: this.providerFilters.searchText,
              categories: this.providerFilters.categoryIds,
              limit: this.providerFilters.limit,
              order: this.order,
              center: `${longitude},${latitude}`
            }); 
            await this.loadData(data);
        } else {
          
          const { data } = await this.$oddjob.serviceProviders
            .findSimple({
              ...resultFilter,
              text: this.providerFilters.searchText,
              categories: this.providerFilters.categoryIds,
              limit: this.providerFilters.limit,
              order: this.order
            });
           await this.loadData(data);
        }
    },
    reloadProviders() {
      this.providers = {
        resultSet: new Date(),
        enableLoadMore: false,
        resultKey: null,
        error: null,
        loading: false,
        data: [],
        providerIds: {}
      };
      return this.fetchProviders();
    },
    async getCategoryDefault(){
      const { data: { results }} = await this.$oddjob.settings.getCategories({ statuses: "active", language: localStorage.language =  localStorage.language || "vi"  });
      if(results && results.length > 0){
        return results[0];
      }
    }
  },
  async mounted() {

    if(this.providerFilters.categoryIds && this.providerFilters.categoryIds.length <= 0){
       let defaultCategory = await this.getCategoryDefault();
       this.providerFilters.categoryIds = [defaultCategory._id];
    }
    
    await this.$store.dispatch("loadLocation");
    await this.reloadProviders();
    // this.$nextTick(() =>{
    //   this.$forceUpdate();
    //   window.onpopstate = () => {
    //     this.$store.dispatch("loadLocation");
    //     this.reloadProviders();
    //   };
    // })
  }
};
</script>
